import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import InvoiceTemplate from './InvoiceTemplate';

export default function PrintInvoice() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') === 'purchase' ? 'purchase' : (searchParams.get('type') === 'pi' ? 'pi' : 'sale');
  const [invoice, setInvoice] = useState(undefined);
  const [items, setItems] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const url = type === 'purchase' ? `/api/purchase-invoices/${id}` : (type === 'pi' ? `/api/proforma-invoices/${id}` : `/api/sale-invoices/${id}`);
        const res = await fetch(url);
        const body = await res.json();
        const data = body?.data || {};
        if (cancelled) return;
        const inv = data.invoice || null;
        if (inv) inv.invoice_type = type === 'pi' ? 'proforma-invoice' : inv.invoice_type;
        setInvoice(inv ? { ...inv, consignee: data.consignee || null, extra: data.extra || null } : null);
        setItems(data.items || []);
        if (inv?.invoice_no) {
          const billedTo = inv.party_name || inv.customer_name || inv.vendor_name || '';
          document.title = billedTo
            ? `${inv.invoice_no} - ${billedTo}`.replace(/[\\/:*?"<>|]/g, '_')
            : inv.invoice_no;
        }
      } catch (e) {
        if (!cancelled) setInvoice(null);
      }
    })();
    return () => { cancelled = true; };
  }, [id, type]);

  useEffect(() => {
    if (ready) {
      const t = setTimeout(() => { window.print(); }, 400);
      return () => clearTimeout(t);
    }
  }, [ready]);

  if (invoice === undefined) {
    return <div style={{ fontFamily: 'Arial', padding: 40, textAlign: 'center' }}>Loading invoice...</div>;
  }
  if (invoice === null) {
    return <div style={{ fontFamily: 'Arial', padding: 40, textAlign: 'center' }}>Invoice not found.</div>;
  }

  return <InvoiceTemplate invoice={invoice} items={items} onReady={() => setReady(true)} hideActions />;
}